/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import { useEffect } from '@wordpress/element';

/**
 * Inner dependencies.
 */
import Inspector from './inspector';
import BaseWrapper from '../../components/base-wrapper';
import { showRatingStar } from './helpers';
import { updateBlockStyle } from './inline-styles';

const Edit = ( props ) => {
	useEffect( () => {
		updateBlockStyle( {}, props );
	}, [] );
	const {
		isSelected,
		className,
		attributes,
	} = props;
	const { textAlignment } = attributes;
	const wrapperClasses = classnames(
		className,
		`is-content-justification-${ textAlignment }`,
	);
	return <div className={ wrapperClasses }>
		{ isSelected && <Inspector { ...props } /> }
		<BaseWrapper { ...props }>
			{ showRatingStar( attributes ) }
		</BaseWrapper>
	</div>;
};

export default Edit;
